import { supabase } from '../lib/supabase';
import { getVisitorHash } from '../utils/visitorId';

export type { FeatureSubmitResult } from './communityFeedbackDb';
export {
  submitDataReport,
  submitPageFeedback,
  submitForumClaim,
  fetchDataReportsAdmin,
  fetchPageFeedbackAdmin,
  fetchForumClaimsAdmin,
  updateDataReportStatus,
  updateForumClaimStatus,
} from './communityFeedbackDb';

function isMissingTable(err: { code?: string; message?: string } | null): boolean {
  if (!err) return false;
  const msg = (err.message || '').toLowerCase();
  return err.code === '42P01' || msg.includes('does not exist') || msg.includes('schema cache');
}

export async function voteSuggestion(suggestionId: string, vote: 1 | -1): Promise<boolean> {
  const { error } = await supabase.from('suggestion_votes').upsert(
    { suggestion_id: suggestionId, voter_hash: getVisitorHash(), vote },
    { onConflict: 'suggestion_id,voter_hash' }
  );
  return !error && !isMissingTable(error);
}

export async function trackSponsoredClick(forumId: string): Promise<void> {
  await supabase.from('sponsored_clicks').insert({
    forum_id: forumId,
    referrer: typeof document !== 'undefined' ? document.referrer?.slice(0, 200) : null,
  });
}

export async function recordCategorySnapshots(): Promise<void> {
  const { data: forums } = await supabase
    .from('forums')
    .select('category, topics_count, posts_count, members_count')
    .eq('is_active', true);
  if (!forums?.length) return;
  const byCat: Record<string, { c: number; t: number; p: number; m: number }> = {};
  for (const f of forums) {
    if (!byCat[f.category]) byCat[f.category] = { c: 0, t: 0, p: 0, m: 0 };
    byCat[f.category].c++;
    byCat[f.category].t += f.topics_count || 0;
    byCat[f.category].p += f.posts_count || 0;
    byCat[f.category].m += f.members_count || 0;
  }
  const rows = Object.entries(byCat).map(([category_name, v]) => ({
    category_name,
    forum_count: v.c,
    total_topics: v.t,
    total_posts: v.p,
    total_members: v.m,
  }));
  await supabase.from('category_stat_snapshots').insert(rows);
}
